import { render, staticRenderFns } from "./ScheduledSendsTable.vue?vue&type=template&id=b5da8fb2&scoped=true"
import script from "./ScheduledSendsTable.vue?vue&type=script&lang=js"
export * from "./ScheduledSendsTable.vue?vue&type=script&lang=js"
import style0 from "./ScheduledSendsTable.vue?vue&type=style&index=0&id=b5da8fb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5da8fb2",
  null
  
)

export default component.exports